import {
	createSlice,
	createEntityAdapter,
	createAsyncThunk,
} from "@reduxjs/toolkit";
import { getAttachmentById, getUploadDocuments } from "api";
import { downloadFile } from "../utils/common";

export const fetchAttachmentById = createAsyncThunk(
	"attachment/fetchAttachmentById",
	async (attachmentId, { rejectWithValue }) => {
		try {
			downloadFile(await getAttachmentById({ attachmentId }));
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const fetchAttachmentsByFormId = createAsyncThunk(
	"attachment/fetchAttachmentsByFormId",
	async (formId, { dispatch, rejectWithValue }) => {
		try {
			dispatch(attachmentsReceived(await getUploadDocuments({ formId })));
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const deleteAttachmentsByQuestionId = createAsyncThunk(
	"attachment/deleteAttachmentsByQuestionId",
	async (questionId, { dispatch, getState, rejectWithValue }) => {
		try {
			const state = getState();
			const attachments = selectAllAttachments(state);
			const toDelete = attachments.filter(
				(a) => a.questionId === questionId
			);
			toDelete.forEach(({ id }) => {
				dispatch(attachmentUpserted({ id, isDeleted: true }));
			});
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const attachmentsAdapter = createEntityAdapter();

const initialState = attachmentsAdapter.getInitialState({
	status: "idle",
	error: null,
});

const attachmentsSlice = createSlice({
	name: "attachments",
	initialState,
	reducers: {
		attachmentsReceived(state, action) {
			attachmentsAdapter.setAll(state, action.payload);
		},
		attachmentUpserted(state, action) {
			if (action.payload.isDeleted) {
				attachmentsAdapter.removeOne(state, action.payload.id);
			} else {
				attachmentsAdapter.upsertOne(state, action.payload);
			}
		},
	},
	extraReducers: {
		[fetchAttachmentById.pending]: (state, action) => {},
		[fetchAttachmentById.fulfilled]: (state, action) => {},
		[fetchAttachmentById.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
		[fetchAttachmentsByFormId.pending]: (state, action) => {},
		[fetchAttachmentsByFormId.fulfilled]: (state, action) => {},
		[fetchAttachmentsByFormId.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
	},
});

/*
ACTIONS
attachments data can only ever be received via API
There are no actions to CRUD individual attachments
*/
export const { attachmentUpserted, attachmentsReceived } =
	attachmentsSlice.actions;

/*
SELECTORS
*/
export const {
	selectAll: selectAllAttachments,
	selectById: selectAttachmentById,
} = attachmentsAdapter.getSelectors((state) => state.attachments);

/*
CUSTOM SELECTORS
*/
export const selectAttachmentsError = (state) => state.attachments.error;

export default attachmentsSlice.reducer;
